module.exports = __webpack_public_path__ + "img/Edit.3a676ea5.svg";